import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage } from "react-intl";
import Select from "react-select";
import { instance } from "Actions/AxiosInstance";
import createstore from "store";
import {
  ValidateAction,
  ValidateList,
  ValidateReqField,
  ValidateReqFields,
  ValidateSearchDropdown,
} from "Utils/Validation";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import DynamicForm from "Component/DynamicForm";
import {
  getNumberValidation,
} from "Utils/arr";

class BankingForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data,
      isdefault: false,
      fields: {
        branchname: "",
        accountholdername: "",
        accountnumber: "",
        ifsccode: "",
        swiftcode: "",
      },
      reqFields: {
        branchname: "",
        accountholdername: "",
        accountnumber: "",
        ifsccode: "",
      },
      list: {
        banknameid: "",
        accounttype: "",
      },
      reqList: {
        banknameid: "",
        accounttype: "",
      },
      errors: {},
      helperText: {},
      banknames: [],
      accounttypes: [],
      isRequestSent: false,
    };

    this.onCancel = this.onCancel.bind(this);
  }

  componentDidMount() {
    // this.props.ChangeLanguage("");
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    const {
      thisempdata: { employeeid, fullname },
    } = this.props;
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        reqFields: {
          ...this.state.reqFields,
          accountholdername: fullname,
        },
        fields: {
          ...this.state.reqFields,
          accountholdername: fullname,
        },
      },
      () => {
        this.GetBanknames();
      },
    );
    if (this.firstElement) this.firstElement.focus();
  }

  GetPerticularBankDetails() {
    if (this.state.data) {
      const { data } = this.state;
      const { isdefault } = data;
      const { employeebankid } = data;
      const fields = {
        branchname: data.branchname,
        accountholdername: data.accountholdername,
        accountnumber: data.accountnumber,
        ifsccode: data.ifsccode,
        isdefault: data.isdefault,
        swiftcode: data.swiftcode || "",
      };
      const reqFields = {
        branchname: data.branchname,
        accountholdername: data.accountholdername,
        accountnumber: data.accountnumber,
        ifsccode: data.ifsccode,
      };
      const list = {
        banknameid: data.banknameid,
        accounttype: data.accounttype,
      };
      const reqList = {
        banknameid: data.banknameid,
        accounttype: data.accounttype,
      };
      // let selectedBankName = this.state.banknames.find(x => x.displayvalue == data.banknameid);
      // let selectedAccountType = this.state.accounttypes.find(x => x.displayvalue == data.accounttype);
      this.setState({
        fields,
        list,
        isdefault,
        employeebankid,
        reqFields,
        reqList,
      });
    }
  }

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    fields[field] = e.target.value ? e.target.value : "";
    this.setState({ fields }, () => {
      // ValidateAction(this.state, field, type);
    });
  }

  ValidateField(reqField, type, e) {
    const { reqFields } = this.state;
    reqFields[reqField] = e.target.value ? e.target.value : "";
    this.setState({ reqFields });
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  ValidateOnNext(reqField, type) {
    const { errors } = this.state;
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
    this.setState({ errors });
  }

  UpdateSelectedId(name, HtField, selectedItem) {
    const { list } = this.state;
    list[name] = selectedItem.displayvalue ? selectedItem.displayvalue : "";
    this.setState({ list });
    if (name == "banknameid") {
      this.setState({ selectedBankName: selectedItem });
    }
    if (name == "accounttype") {
      this.setState({ selectedAccountType: selectedItem });
    }

    const { reqList } = this.state;
    if (reqList[name] == "" || reqList[name] || reqList[name] == null) {
      reqList[name] = selectedItem.displayvalue
        ? selectedItem.displayvalue
        : "";
      this.setState({ reqList }, () => {
        this.ValidateEachDropDown(name);
      });
    }
  }

  ValidateEachDropDown(name) {
    ValidateSearchDropdown(this.state, name).then((result) => {
      this.setState({
        errors: result.errors,
      });
    });
  }

  GetBanknames() {
    const data = this.state.data || {};
    const data1 = {
      countryid: null,
      subscriptionid: this.state.subscriptionid,
    };
    instance
      .post("superuser/allbankmaster", data1)
      .then((result) => {
        const banknames = [];
        banknames.push(
          { displayname: "Select Bank Name", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ banknames }, () => {
          this.setState({
            selectedBankName: banknames.find(
              (x) => x.displayvalue == data.banknameid,
            ),
          });
        });
        this.GetAccountType();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetAccountType() {
    const data = this.state.data || {};
    instance
      .get("superuser/getmastercode/AccountType")
      .then((result) => {
        let accounttypes = [];
        accounttypes = result.data.result;
        this.setState({ accounttypes }, () => {
          this.setState({
            selectedAccountType: accounttypes.find(
              (x) => x.displayvalue == data.accounttype,
            ),
          });
        });
        this.GetPerticularBankDetails();
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  Validate() {
    let formIsValid = true;

    if (!ValidateReqFields(this.state)) {
      formIsValid = false;
    }
    if (!ValidateList(this.state)) {
      formIsValid = false;
    }
    return formIsValid;
  }

  AddBankDetails = () => {
    const { fields, list } = this.state;
    if (
      !list.banknameid ||
      !list.accounttype ||
      !fields.accountholdername ||
      !fields.accountnumber ||
      !fields.branchname ||
      !fields.ifsccode
    ) {
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });
    }else if( getNumberValidation(this.state.fields.accountnumber) == false ){
      this.props.enqueueSnackbar("Invalid bank account", {
        variant: "error",
      });
    } else {
      let flag;
      // this.state.employeebankid ? flag = 3 : flag = 2
      if (
        !createstore.getState().AuthenticationAction.IsFulfilled ||
        this.state.employeebankid
      ) {
        flag = 3;
      } else {
        flag = 2;
      }
      const { issaveinprogress } = this.props.SaveInProgressReducer;
      console.log("issaveinprogress: ", issaveinprogress);
      if (!issaveinprogress) {
        this.props.setSaveProgress(true);
        const data = {
          employeebankid: this.state.employeebankid,
          banknameid: this.state.list.banknameid,
          branchname: this.state.fields.branchname,
          accountholdername: this.state.fields.accountholdername,
          accountnumber: this.state.fields.accountnumber,
          accounttype: this.state.list.accounttype,
          ifsccode: this.state.fields.ifsccode,
          isdefault: true, // this.state.isdefault,
          employeeid: this.state.employeeid,
        };
        if (!createstore.getState().AuthenticationAction.IsFulfilled) {
          Object.assign(data, {
            accountid: this.state.accountid,
            subscriptionid: this.state.subscriptionid,
            timezoneid: this.state.countrytimezoneid,
            employeeid: this.state.employeeid,
          });
        }
        instance
          .post("employee/insertupdateempbankdetail", data)
          .then((result) => {
            this.props.enqueueSnackbar("Bank Details Saved successfully", {
              variant: "success",
            });
            this.props.removeSaveProgress();
            this.setState(
              {
                employeebankid: "",
                banknameid: "",
                branchname: "",
                accountnumber: "",
                accounttype: "",
                ifsccode: "",
                swiftcode: "",
                isdefault: "",
                selectedBankName: "",
                selectedAccountType: "",
                isRequestSent: false,
              },
              () => {
                this.submitPaymentType(result.data.result[0].employeebankid);
              },
            );
            // this.props.SetFlag(flag, true);
          })
          .catch((error) => {
            this.props.removeSaveProgress();
            const CommonError = error.response
              ? error.response.data.error.message
              : error.message;
            this.props.enqueueSnackbar(CommonError, { variant: "error" });
          });
      }
    }
  };

  onCancel() {
    const { drawerData, setdrawerData } = this.props;
    setdrawerData(drawerData.map((x) => ({ ...x, isexpanded: false })));
    // this.props.SetFlag(3, true);
  }

  submit = () => {
    const { paymentType } = this.state;
    if (!paymentType) return;
    if (paymentType == 62) {
      this.AddBankDetails();
    } else {
      this.submitPaymentType();
    }
  };

  ChangeIsDefaultState(name, event) {
    let isRequestSent = false;
    if (this.state.employeebankid && this.state.isdefault == false) {
      event.target.checked == true
        ? (isRequestSent = true)
        : (isRequestSent = false);
    }
    this.setState({ [name]: event.target.checked, isRequestSent });
  }

  submitPaymentType = (employeebankid) => {
    console.log("employeebankid: ", employeebankid);
    const { paymentType } = this.state;
    console.log("paymentType: ", paymentType);
    const {
      drawerData,
      setdrawerData,
      salarycycle,
      payrollcycledurationid,
      closeMissingInfoDrawer,
    } = this.props;
    const thisempdata = drawerData.find((x) => x.isexpanded);
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    console.log("issaveinprogress: ", issaveinprogress);
    if (!issaveinprogress) {
      this.props.setSaveProgress(true);
      const data = {
        employeesalarymodes: [
          {
            employeeid: thisempdata.employeeid,
            paymentmodetypeid: paymentType,
            employeebankid: employeebankid || null,
          },
        ],
        salarycycleid: salarycycle.salarycycleid,
        salarycyclesplitid: salarycycle.displayvalue,
        payrollcycledurationid,
      };
      instance
        .post("payroll/createtempsalarymode", data)
        .then(() => {
          this.props.removeSaveProgress();
          setdrawerData(drawerData.filter((x) => !x.isexpanded));
          // this.props.geterrors();
          this.props.getData(thisempdata.employeeid);
          drawerData.filter((x) => !x.isexpanded).length < 1 &&
            closeMissingInfoDrawer();
        })
        .catch((error) => {
          this.props.removeSaveProgress();
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  };

  renderbankform() {
    return (
      <div autoComplete="off">
        <div tabIndex="0">
          <p className="input-label margin-top-8">
            <FormattedMessage id="LbBankName" defaultMessage="Bank Name" />{" "}
          </p>
          <Select
            className="selectsearch"
            onChange={this.UpdateSelectedId.bind(
              this,
              "banknameid",
              "HtBankName",
            )}
            options={this.state.banknames}
            getOptionLabel={(option) => option.displayname}
            getOptionValue={(option) => option.displayvalue}
            value={this.state.selectedBankName}
            placeholder="Select Bank Name"
            ref={(r) => {
              this.firstElement = r;
            }}
            // selected={(option)=>option.displayvalue == props.Selected}
          />

          {this.state.errors.banknameid ? (
            <span className="caption-error">
              <FormattedMessage
                id="Erbankname"
                defaultMessage="please select Bank Name"
              />
            </span>
          ) : (
            ""
          )}
        </div>
        <div tabIndex="1">
          <p className="input-label margin-top-8">
            <FormattedMessage id="LbBranchName" defaultMessage="Branch Name" />
          </p>

          <TextField
            id="outlined-dense"
            margin="dense"
            variant="outlined"
            className="width100 bg-color-white"
            placeholder="Branch Name"
            onChange={this.OnFieldChange.bind(this, "branchname", "name")}
            // onBlur={this.ValidateField.bind(
            //   this,
            //   "branchname",
            //   "name",
            // )}
            value={this.state.fields.branchname}
            maxLength="90"
          />

          {this.state.errors.branchname ? (
            <span className="caption-error">
              {" "}
              <FormattedMessage
                id="Erbranchname"
                defaultMessage="can not be empty"
              />
            </span>
          ) : (
            ""
          )}
        </div>
        <div tabIndex="2">
          <p className="input-label margin-top-8">
            <FormattedMessage
              id="LbAccountHolderName"
              defaultMessage="Account Holder Name"
            />
          </p>

          <TextField
            id="outlined-dense"
            margin="dense"
            variant="outlined"
            className="width100 bg-color-white"
            placeholder="Account Holder Name"
            onChange={this.OnFieldChange.bind(
              this,
              "accountholdername",
              "text",
            )}
            // onBlur={this.ValidateField.bind(
            //   this,
            //   "accountholdername",
            //   "name",
            // )}
            value={this.state.fields.accountholdername}
            maxLength="90"
          />

          {this.state.errors.accountholdername ? (
            <span className="caption-error">
              {" "}
              <FormattedMessage
                id="Eraccountholdername"
                defaultMessage="can not be empty"
              />
            </span>
          ) : (
            ""
          )}
        </div>
        <div tabIndex="3">
          <p className="input-label margin-top-8">
            <FormattedMessage
              id="LbAccountNumber"
              defaultMessage="Account Number"
            />
          </p>

          <TextField
            id="outlined-dense"
            margin="dense"
            variant="outlined"
            className="width100 bg-color-white"
            placeholder="Account Number"
            onChange={this.OnFieldChange.bind(this, "accountnumber", "text")}
            // onBlur={this.ValidateField.bind(
            //   this,
            //   "accountnumber",
            //   "text",
            // )}
            value={this.state.fields.accountnumber}
            maxLength="40"
          />

          {this.state.errors.accountnumber ? (
            <span className="caption-error">
              {" "}
              <FormattedMessage
                id="Eraccountnumber"
                defaultMessage="can not be empty"
              />
            </span>
          ) : (
            ""
          )}
        </div>
        <div tabIndex="4">
          <p className="input-label margin-top-8">
            <FormattedMessage id="LbAccountType" defaultMessage="AccountType" />{" "}
          </p>
          <Select
            className="selectsearch"
            onChange={this.UpdateSelectedId.bind(
              this,
              "accounttype",
              "HtAccountType",
            )}
            options={this.state.accounttypes}
            getOptionLabel={(option) => option.displayname}
            getOptionValue={(option) => option.displayvalue}
            value={this.state.selectedAccountType}
            placeholder="Select Account Type"
            // selected={(option)=>option.displayvalue == props.Selected}
          />

          {this.state.errors.accounttype ? (
            <span className="caption-error">
              <FormattedMessage
                id="ErAccountType"
                defaultMessage="please select Account Type"
              />
            </span>
          ) : (
            ""
          )}
        </div>
        <div tabIndex="5">
          <p className="input-label margin-top-8">
            <FormattedMessage id="LbIFSCcode" defaultMessage="IFSC code" />
          </p>
          <div className="margin-bottom-16">
          <TextField
            id="outlined-dense"
            margin="dense"
            variant="outlined"
            className="width100 bg-color-white"
            placeholder="IFSC code"
            onChange={this.OnFieldChange.bind(this, "ifsccode", "text")}
            // onBlur={this.ValidateField.bind(this, "ifsccode", "text")}
            value={this.state.fields.ifsccode}
            maxLength="40"
          />
           </div>

          {this.state.errors.ifsccode ? (
            <span className="caption-error">
              {" "}
              <FormattedMessage
                id="Erifsccode"
                defaultMessage="can not be empty"
              />
            </span>
          ) : (
            ""
          )}
        </div>
        {/* <div tabIndex="5">
          <p className="input-label margin-top-8">
            <FormattedMessage
              id="__LbSwiftCode"
              defaultMessage="Swift code (Optional)"
            />
          </p>
          <div className="margin-bottom-16">
            <TextField
              id="outlined-dense"
              margin="dense"
              variant="outlined"
              className="width100 bg-color-white"
              placeholder="Swift code"
              onChange={this.OnFieldChange.bind(this, "swiftcode", "text")}
              // onBlur={this.ValidateField.bind(
              //   this,
              //   "swiftcode",
              //   "text",
              // )}
              value={this.state.fields.swiftcode}
              maxLength="40"
            />
          </div>
        </div> */}
      </div>
    );
  }

  render() {
    const { paymentType } = this.state;
    return (
      <div>
        <DynamicForm
          fields={selectinputconverter({
            value: this.state.paymentType,
            options: [
              { displayname: "Cash", displayvalue: 60 },
              { displayname: "Cheque", displayvalue: 61 },
              { displayname: "Bank transfer", displayvalue: 62 },
            ],
            placeholder: "Select payment method",
            label: "Payment method",
          })}
          onChange={(e) => this.setState({ paymentType: e })}
        />

        {paymentType && paymentType === 62 && this.renderbankform()}

        <div className="upform-footer">
          <Button
            variant="contained"
            className="btn btn-primary-sm-blue"
            onClick={this.submit}
            disabled={this.props.SaveInProgressReducer.issaveinprogress}
            // onClick={this.AddBankDetails.bind(this)}
          >
            <FormattedMessage id="BtSave" defaultMessage="Save" />
          </Button>
          <span className="margin-left-16"></span>
          <Button className="btn btn-trans" onClick={this.onCancel}>
            <FormattedMessage id="BtCancel" defaultMessage="Cancel" />
          </Button>
        </div>
      </div>
    );
  }
}

export default withSnackbar(BankingForm);
